import { Component, Input } from '@angular/core';
import { AbstractControl, FormArray } from '@angular/forms';
import { massValidationMessage } from './data-entity-mass-form.validators';

@Component({
  selector: 'app-data-entity-mass-n-models',
  templateUrl: './DataEntityMassNModels.component.html',
  styleUrls: ['./DataEntityMassNModels.component.scss']
})
export class DataEntityMassNModelsComponent {
  @Input() nModels: FormArray;

  @Input() decisionRules: { value: number, label: string }[] = [];
  decisionRuleLabel(value: number): string { const rule = this.decisionRules.find(rule => rule.value === value); return rule ? rule.label : 'قانون تصمیم: ' + value; }

  validationMessage(control: AbstractControl): string { return massValidationMessage(control); }

  trackByIndex(index: number): number {
    return index;
  }
}
